<template>
  <div class="py-0 container-fluid">
    <div class="row">
      <div class="col-md-12 border-radius-xl p-3 mb-3" style="background-color: #ffffff29;">
        <img src="../assets/img/Addiuva_BrandBackground-1920x1080.png" width="100%">
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Home",
  components: {},
  methods: {
  },
  mounted() {
  },
  computed: {
  },
};
</script>
